<template>
  <Modal v-model="visible" title="其他加扣款" width="800" class="my-modal top p-b" :mask-closable="false" :footer-hide="true">
    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData" row-key="id"> </Table>
    </div>
  </Modal>
</template>

<script>
export default {
  props: ['reportId'],
  data() {
    return {
      visible: false,
      loading: false,
      columns: [
        {
          title: '加扣款名称',
          align: 'center',
          key: 'deductionName',
          minWidth: 250,
          render: (h, params) => {
            return h('Form', [
              h('Input', {
                props: {
                  type: 'text',
                  disabled: true,
                  value: params.row['deductionName']
                },
                on: {
                  input: event => {
                    this.tableData[params.index]['deductionName'] = event;
                  }
                }
              })
            ]);
          }
        },
        {
          title: '加扣款金额（税前）',
          align: 'center',
          key: 'deduction',
          minWidth: 250,
          render: (h, params) => {
            return h('Form', [
              h('Input', {
                props: {
                  type: 'text',
                  disabled: true,
                  value: params.row['deduction']
                },
                on: {
                  input: event => {
                    this.tableData[params.index]['deduction'] = event;
                  }
                }
              })
            ]);
          }
        }
      ],
      tableData: [],
      userId: null
    };
  },
  methods: {
    open(userId) {
      this.visible = true;
      this.userId = userId;
      this.getList();
    },

    getList() {
      this.$http({
        url: '/buz/userSalaryDeduction/queryList',
        type: 'POST',
        data: {
          userId: this.userId
        }
      }).then(res => {
        this.tableData = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-box {
  margin-top: 10px;
}
</style>
